import { clearTimeouts, engine as anime } from "../index";

const timeouts = [];

const main = (props) => {
  const timeouts = [];
  const { id, format } = props;

  const timeline = anime.timeline();

  $(`#${id} .teams-block .home, #${id} .teams-block .away`).css("opacity", 0);
  $(`#${id} .headline`).css("opacity", 0);
  $(`#${id} .team-vs`).css("opacity", 0);
  $(`#${id} .teams-block > .team-vs`).css("opacity", 0);
  $(`#${id} .date-container, #${id} .hashtag`).css("opacity", 0);

  anime({
    targets: [`#${id} .custom-background`],
    duration: 3000,
    easing: "easeOutQuint",
    opacity: [0, 1],
    scale: [
      { value: [1.8, 1] },
      { value: [1, 1.1], duration: 12000, easing: "linear" },
    ],
    delay: 200,
  });

  anime({
    targets: [`#${id} .team-vs`],
    scale: [
      {
        value: [0, 1],
        duration: 800,
      },
    ],
    easing: "easeInOutQuint",
    opacity: [1, 1],
    delay: 800,
  });

  anime({
    targets: [`#${id} .teams-block .home`],
    duration: 800,
    easing: "easeOutQuint",
    translateX: [-600, 0],
    opacity: [1, 1],
    delay: 1200,
  });

  anime({
    targets: [`#${id} .teams-block .away`],
    duration: 800,
    easing: "easeOutQuint",
    translateX: [600, 0],
    opacity: [1, 1],
    delay: 1200,
  });

  const timeout1 = setTimeout(() => {
    anime({
      targets: [`#${id} .date-container`],
      duration: 800,
      easing: "easeInOutQuint", // translateX: [-800, 0],
      opacity: [1, 1],
      scale: [0, 1],
      delay: 0,
    });

    anime({
      targets: [`#${id} .hashtag`],
      duration: 800,
      easing: "easeInOutQuint", // translateX: [-800, 0],
      opacity: [1, 1],
      scale: [0, 1],
      filter: ["blur(50px)", "blur(0)"],
      delay: 0,
    });
  }, 1000);

  timeouts.push(timeout1);
  // timeouts.push(timeout3);

  return {
    timeline: timeline,
    timeouts: timeouts,
  };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
  const { timeouts } = animationReturn;
  clearTimeouts(timeouts);
};

export default main;
